module.exports = __webpack_public_path__ + "static/img/banner04.baf39f31.webp";